// Import controller interfaces
import {
    IClaimsController
} from '../Interfaces/ControllerInterfacesBarrel';
// Import api models.
import {
    PolicyLoss
} from '@app/models/api';

export default class MockClaimsController implements IClaimsController {

    public constructor() {

    }

    public async getPolicyLosses(policyId: number): Promise<PolicyLoss[]> {
        throw new Error('Method not implemented.');
    }

    public async submitClaim(policyId: number, claim: PolicyLoss): Promise<string> {
        throw new Error('Method not implemented.');
    }

    public async isPolicyAllowedToMakeClaims(policyId: number): Promise<boolean> {
        throw new Error('Method not implemented.');
    }

    public async getPolicyLossesPublic(policyId: number, zipCode: string): Promise<PolicyLoss[]> {
        throw new Error('Method not implemented.');
    }

    public async submitClaimPublic(policyId: number, zipCode: string, claim: PolicyLoss): Promise<string> {
        throw new Error('Method not implemented.');
    }

    public async isPolicyAllowedToMakeClaimsPublic(policyId: number, zipCode: string): Promise<boolean> {
        throw new Error('Method not implemented.');
    }
};